<form [formGroup]="formSearch" id="addressLookup{{index}}">
  <div class="form-group" [ngClass]="{'is-invalid':isPostcodeInvalid }">
    <div class="input-group" id="postcode{{index}}">
            <input type=" text"  [ngClass]="{'is-invalid':(isPostcodeInvalid || (formSearch.get('hasSearched').touched && formSearch.get('hasSearched').invalid)),
             'is-valid':(formSearch.get('postcode').touched && formSearch.get('hasSearched').valid)}"
        class="form-control postcode" placeholder="Enter postcode" formControlName="postcode" [ngClass]="{ 'form-control-danger':isPostcodeInvalid}">
        <span class="input-group-btn">
          <button class="c-button c-button--input-brand btn" type="button" id="lookup{{index}}" (click)="doLookup()"  [disabled]="!searchButtonEnabled">Find</button>
        </span>
      </div>
      @if ((isPostcodeInvalid && formSearch.get('postcode').errors?.required)) {
        <div class="invalid-feedback d-flex">We need the address.</div>
      }
      @if (isPostcodeInvalid && formSearch.get('postcode').errors?.pattern) {
        <div class="invalid-feedback d-flex">Please enter a valid, full postcode.</div>
      }
      @if (!isPostcodeInvalid && formSearch.get('hasSearched').touched && formSearch.get('hasSearched').errors?.required) {
        <div class="invalid-feedback d-flex">Please lookup the address.</div>
      }
      @if (isSearchReturnedNoResults) {
        <div class="invalid-feedback d-flex">No matching addresses for {{formSearch.get('postcode').value}}</div>
      }
      <button class="c-button c-button--help mb-2" type="button" (click)="switchManualEdit()">Or enter the address manually</button>
    </div>
    @if (hasSearchResults) {
      <div>
        <fieldset class="form-group" id="qasResult{{index}}" [ngClass]="{'is-invalid': formSearch.get('hasAddressSelected').touched && formSearch.get('hasAddressSelected').invalid,
        'is-valid': formSearch.get('hasAddressSelected').touched && formSearch.get('hasAddressSelected').valid }">
          <div class="c-radio--scrollbox custom-controls-stacked">
            @for (line of searchResults; track line; let i = $index) {
              <span class="c-radio-button">
                <label class="custom-control custom-radio">
                  <input id="radioStacked{{i}}" name="matchedAddress" formControlName="matchedAddress" type="radio"
                    class="custom-control-input" value="{{line.resultId}}">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">{{line.singleLine}}</span>
                  </label>
                </span>
              }
            </div>
          </fieldset>
          @if (formSearch.get('hasAddressSelected').errors?.required) {
            <div class="invalid-feedback d-flex">Please select address</div>
          }
        </div>
      }
    </form>
    <together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>
